import { get } from './api';

export const allergyAPI = {
  getAllergies() {
    return get('allergies');
  },
};
